<template>
  <form class="switcher">
    <input
      class="switcher__prev"
      autocomplete="off"
      title="Предыдущий месяц"
      type="button"
      v-on:click="toPrev"
    />
    <output
      class="switcher__title"
      for="next-month prev-month"
    >{{ monthTitle }} {{ yearTitle }}</output>
    <input
      class="switcher__next"
      autocomplete="off"
      title="Следующий месяц"
      type="button"
      v-on:click="toNext"
    />
  </form>
</template>
<script>
/**
 * @description Перевести первый символ строки в верхний регистр.
 * @param {string} word Строка.
 * @returns {string}
 */
const capitalize = (word) => word.charAt(0).toUpperCase() + word.slice(1);

/**
 * @description Компонент переключателя даты.
 */
export default {
  computed: {
    monthTitle: (vm) => capitalize(vm.date.toLocaleString('ru', { month: 'long' })),
    yearTitle: (vm) => vm.date.getFullYear(),
  },
  data() {
    return {
      date: this.value,
    };
  },
  methods: {
    /**
     * @description Перейти к следующему месяцу.
     * @returns {void}
     */
    toNext() {
      const nextMonthDate = new Date(this.date);
      nextMonthDate.setDate(1);
      nextMonthDate.setMonth(this.date.getMonth() + 1);
      this.date = nextMonthDate;
    },
    /**
     * @description Перейти к предыдущему месяцу.
     * @returns {void}
     */
    toPrev() {
      const prevMonthDate = new Date(this.date);
      prevMonthDate.setMonth(this.date.getMonth() - 1);
      this.date = prevMonthDate;
    },
  },
  props: {
    /**
     * @description Изначальная дата.
     * @type {Date}
     */
    value: Date,
  },
  watch: {
    date(value) {
      this.$emit('input', value);
    },
  },
};
</script>
<style scoped lang="scss">
.switcher {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 5px;
  width: 100%;
  &__title {
    width: min(100%, 200px);
    font-weight: 600;
    font-size: 25px;
    line-height: 30px;
    color: #0489E0;
    text-align: center;
  }
  &__next,
  &__prev {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    min-width: 20px;
    height: 20px;
    min-height: 20px;
    border-radius: 50%;
    border: 1px solid #90A0B7;
    background-position: center;
    background-repeat: no-repeat;
    &:hover {
      border: 1px solid #0489E0;
    }
  }
  &__next {
    background-image: url("@/assets/img/arrow/arrow-next-grey.svg");
    &:hover {
      background-image: url("@/assets/img/arrow/arrow-next-blue.svg");
    }
  }
  &__prev {
    background-image: url("@/assets/img/arrow/arrow-prev-grey.svg");
    &:hover {
      background-image: url("@/assets/img/arrow/arrow-prev-blue.svg");
    }
  }
}

@media screen and (max-width: 480px) {
  .switcher {
    &__title {
      width: min(100%, 170px);
      font-size: 22px;
    }
  }
}
</style>
